import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';
import { useEffect, useState } from 'react'
import Select from 'components/general/ViewportSelect';
import StandardModal from '../../general/defaultModals/StandardModal'
import { getContestPluginConfig } from '../../../services/contestPlugin'

export default function MeetingAddNewModal({ getMeetings = null, triggerMode = 'button', onOpen = null, openKey = 0, navigationParent = null }) {
    const url = process.env.REACT_APP_URL;
    const { user: authUser } = useSelector(x => x.auth);

    const [showNewMeetingModal, setShowNewMeetingModal] = useState(false);
    const [theme, setTheme] = useState(document.body.getAttribute('data-theme') || 'light');
    const [selectedDate, setSelectedDate] = useState(null);
    const [meetingTime, setMeetingTime] = useState('18:30');
    const [meetingMode, setMeetingMode] = useState('inPerson');
    const [meetingAddress, setMeetingAddress] = useState('');
    const [meetingOnlineLink, setMeetingOnlineLink] = useState('');
    const [meetingOnlinePasscode, setMeetingOnlinePasscode] = useState('');
    const [meetingNumber, setMeetingNumber] = useState('');
    const [meetingTheme, setMeetingTheme] = useState('');
    const [meetingCardDisplayRole, setMeetingCardDisplayRole] = useState('Toastmaster');
    const [agendaTemplates, setAgendaTemplates] = useState([]);
    const [meetingRoles, setMeetingRoles] = useState([]);
    const [agendaTemplate, setAgendaTemplate] = useState('');
    const [contestPluginEnabled, setContestPluginEnabled] = useState(false);
    const [isContest, setIsContest] = useState(false);
    const [showClockText, setShowClockText] = useState(true);
    const [contestTypesSelected, setContestTypesSelected] = useState([]);
    const [contestTypes, setContestTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setTheme(document.body.getAttribute('data-theme') || 'light');
        });
        observer.observe(document.body, { attributes: true, attributeFilter: ['data-theme'] });
        return () => observer.disconnect();
    }, []);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: theme === 'dark' ? '#23272b' : '#fff',
            color: theme === 'dark' ? '#fff' : '#222',
            borderColor: state.isFocused ? (theme === 'dark' ? '#FFD700' : '#004165') : (theme === 'dark' ? '#444' : '#ccc'),
            boxShadow: state.isFocused ? `0 0 0 2px ${theme === 'dark' ? '#FFD700' : '#004165'}` : 'none',
            minHeight: '44px',
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: theme === 'dark' ? '#23272b' : '#fff',
            color: theme === 'dark' ? '#fff' : '#222',
            zIndex: 9999,
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 2000,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'dark' ? '#fff' : '#222',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? (theme === 'dark' ? '#FFD700' : '#004165')
                : state.isFocused
                    ? (theme === 'dark' ? 'rgba(255,215,0,0.08)' : 'rgba(0,65,101,0.08)')
                    : (theme === 'dark' ? '#23272b' : '#fff'),
            color: state.isSelected
                ? (theme === 'dark' ? '#23272b' : '#fff')
                : (theme === 'dark' ? '#fff' : '#222'),
            fontWeight: state.isSelected ? 700 : 400,
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'dark' ? '#fff' : '#222',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: theme === 'dark' ? '#888' : '#888',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: theme === 'dark' ? '#FFD700' : '#004165',
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: theme === 'dark' ? '#FFD700' : '#004165',
        }),
    };

    // Fetch config every time modal is opened
    const handleShowNewMeetingModal = async () => {
        if (onOpen) onOpen();
        setShowNewMeetingModal(true);
        setLoading(true);
        getContestPluginConfig(authUser.token).then(config => {
            setContestPluginEnabled(config.enabled);
            setContestTypes(config.contestTypes);
            setIsContest(false);
            setContestTypesSelected([]);
        }).catch(() => { setContestPluginEnabled(false); setContestTypes([]); });
        try {
            let data = null;
            let configuredDisplayRole = 'Toastmaster';
            try {
                const configRes = await fetch(`${url}/meetingsConfig`, {
                    headers: { 'Authorization': `Bearer ${authUser.token}` }
                });
                if (configRes.ok) {
                    data = await configRes.json();
                    setMeetingTime(data.time || '');
                    const defaultMode = data.defaultMeetingMode === 'online' ? 'online' : 'inPerson';
                    const defaultInPersonAddress = data.inPersonAddress ?? data.location ?? '';
                    const defaultOnlineLink = data.onlineMeetingLink ?? '';
                    setMeetingAddress(defaultInPersonAddress);
                    setMeetingOnlineLink(defaultOnlineLink);
                    setMeetingMode(defaultMode);
                    setMeetingTheme(data.title || '');
                    configuredDisplayRole = data.meetingCardDisplayRole || (Array.isArray(data.meetingCardDisplayRoles) && data.meetingCardDisplayRoles.length > 0 ? data.meetingCardDisplayRoles[0] : 'Toastmaster');
                    setAgendaTemplate(data.defaultAgendaTemplate || '');
                }
            } catch { }

            try {
                const rolesRes = await fetch(`${url}/meetingRoles`, {
                    headers: { 'Content-Type': 'application/json' }
                });
                if (rolesRes.ok) {
                    const rolesData = await rolesRes.json();
                    const normalizedRoles = Array.isArray(rolesData) ? rolesData : [];
                    setMeetingRoles(normalizedRoles);

                    const matchedRole = normalizedRoles.find(role => (
                        String(role?._id || '') === String(configuredDisplayRole || '') ||
                        String(role?.name || '').toLowerCase() === String(configuredDisplayRole || '').toLowerCase()
                    ));
                    setMeetingCardDisplayRole(matchedRole?.name || configuredDisplayRole || 'Toastmaster');
                } else {
                    setMeetingRoles([]);
                    setMeetingCardDisplayRole(configuredDisplayRole || 'Toastmaster');
                }
            } catch {
                setMeetingRoles([]);
                setMeetingCardDisplayRole(configuredDisplayRole || 'Toastmaster');
            }

            try {
                const templatesRes = await fetch(`${url}/agendatemplates`, {
                    headers: { 'Authorization': `Bearer ${authUser.token}` }
                });
                if (templatesRes.ok) {
                    const templatesData = await templatesRes.json();
                    setAgendaTemplates(Array.isArray(templatesData) ? templatesData : []);
                } else {
                    setAgendaTemplates([]);
                }
            } catch {
                setAgendaTemplates([]);
            }

            let candidate = null;
            const getNextCandidateDate = (config) => {
                // console.log('Config for calculating next candidate date: ', config);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                let base = new Date(today);
                let candidate = new Date(today);
                if (config.dayOfWeek) {
                    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                    const idx = days.indexOf(config.dayOfWeek.toLowerCase());
                    if (idx !== -1) {
                        let diff = (idx + 7 - today.getDay()) % 7;
                        if (diff === 0) diff = 7;
                        candidate.setDate(today.getDate() + diff);
                        base = new Date(candidate);
                    }
                }
                const freq = (config.frequency || '').toLowerCase();
                switch (freq) {
                    case 'daily':
                        candidate = new Date(today);
                        candidate.setDate(today.getDate() + 1);
                        break;
                    case 'weekly':
                        break;
                    case 'bi-weekly':
                    case 'biweekly':
                        if (base.getTime() > today.getTime()) {
                            candidate = new Date(base);
                        } else {
                            candidate = new Date(base);
                            candidate.setDate(candidate.getDate() + 14);
                        }
                        break;
                    case 'monthly':
                        if (base.getTime() > today.getTime()) {
                            candidate = new Date(base);
                        } else {
                            candidate = new Date(base);
                            candidate.setMonth(candidate.getMonth() + 1);
                        }
                        break;
                    case 'quarterly':
                        if (base.getTime() > today.getTime()) {
                            candidate = new Date(base);
                        } else {
                            candidate = new Date(base);
                            candidate.setMonth(candidate.getMonth() + 3);
                        }
                        break;
                    case 'half-yearly':
                    case 'half yearly':
                        if (base.getTime() > today.getTime()) {
                            candidate = new Date(base);
                        } else {
                            candidate = new Date(base);
                            candidate.setMonth(candidate.getMonth() + 6);
                        }
                        break;
                    case 'yearly':
                        if (base.getTime() > today.getTime()) {
                            candidate = new Date(base);
                        } else {
                            candidate = new Date(base);
                            candidate.setFullYear(candidate.getFullYear() + 1);
                        }
                        break;
                    default:
                        break;
                }
                candidate.setHours(0, 0, 0, 0);
                return candidate;
            };

            if (data) {
                candidate = getNextCandidateDate(data);
            } else {
                candidate = new Date();
                candidate.setHours(0, 0, 0, 0);
            }
            let usedDates = [];
            try {
                const meetingsRes = await fetch(`${url}/meetings?page=1&limit=10`, {
                    headers: { 'Authorization': `Bearer ${authUser.token}` }
                });
                if (meetingsRes.ok) {
                    const meetings = await meetingsRes.json();
                    let meetingsArr = Array.isArray(meetings) ? meetings : (Array.isArray(meetings.data) ? meetings.data : []);
                    usedDates = meetingsArr.map(m => m && m.meetingDate ? m.meetingDate : '').filter(Boolean);
                }
            } catch { }
            const formatDate = d => {
                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                return `${day}/${month}/${year}`;
            };
            const normalizeDateString = str => {
                if (!str) return '';
                const parts = str.trim().split('/');
                if (parts.length !== 3) return str.trim();
                const day = parts[0].padStart(2, '0');
                const month = parts[1].padStart(2, '0');
                const year = parts[2];
                return `${day}/${month}/${year}`;
            };
            usedDates = usedDates.map(normalizeDateString);

            let latestMeetingNumber = '';
            const parseDate = str => {
                if (!str) return null;
                const [day, month, year] = str.split('/').map(Number);
                if (!day || !month || !year) return null;
                return new Date(year, month - 1, day);
            };
            let meetingsArr = [];
            try {
                const meetingsRes = await fetch(`${url}/meetings?page=1&limit=10`, {
                    headers: { 'Authorization': `Bearer ${authUser.token}` }
                });
                if (meetingsRes.ok) {
                    const meetings = await meetingsRes.json();
                    meetingsArr = Array.isArray(meetings) ? meetings : (Array.isArray(meetings.data) ? meetings.data : []);
                    usedDates = meetingsArr.map(m => m && m.meetingDate ? m.meetingDate : '').filter(Boolean);
                }
            } catch { }
            usedDates = usedDates.map(normalizeDateString);
            let latestMeeting = null;
            for (const m of meetingsArr) {
                const d = parseDate(m.meetingDate);
                const num = parseInt(m.meetingNumber, 10);
                if (!d || isNaN(num)) continue;
                if (!latestMeeting) {
                    latestMeeting = m;
                } else {
                    const latestDate = parseDate(latestMeeting.meetingDate);
                    const latestNum = parseInt(latestMeeting.meetingNumber, 10);
                    if ((d > latestDate) || (d.getTime() === latestDate.getTime() && num > latestNum)) {
                        latestMeeting = m;
                    }
                }
            }
            if (latestMeeting && latestMeeting.meetingNumber) {
                const num = parseInt(latestMeeting.meetingNumber, 10);
                if (!isNaN(num)) {
                    latestMeetingNumber = String(num + 1);
                }
            }

            let tries = 0;
            const todayMidnight = new Date();
            todayMidnight.setHours(0, 0, 0, 0);
            let candidateStr = formatDate(candidate);
            const incrementCandidate = (date, freq) => {
                let d = new Date(date);
                switch ((freq || '').toLowerCase()) {
                    case 'daily':
                        d.setDate(d.getDate() + 1);
                        break;
                    case 'weekly':
                        d.setDate(d.getDate() + 7);
                        break;
                    case 'bi-weekly':
                    case 'biweekly':
                        d.setDate(d.getDate() + 14);
                        break;
                    case 'monthly':
                        d.setMonth(d.getMonth() + 1);
                        break;
                    case 'quarterly':
                        d.setMonth(d.getMonth() + 3);
                        break;
                    case 'half-yearly':
                    case 'half yearly':
                        d.setMonth(d.getMonth() + 6);
                        break;
                    case 'yearly':
                        d.setFullYear(d.getFullYear() + 1);
                        break;
                    default:
                        d.setDate(d.getDate() + 7);
                        break;
                }
                d.setHours(0, 0, 0, 0);
                return d;
            };
            const freq = data && data.frequency ? data.frequency : 'weekly';
            while ((usedDates.includes(candidateStr) || candidate.getTime() <= todayMidnight.getTime()) && tries < 52) {
                candidate = incrementCandidate(candidate, freq);
                candidateStr = formatDate(candidate);
                tries++;
            }
            setSelectedDate(new Date(candidate));
            setMeetingNumber(latestMeetingNumber);
            setLoading(false);
        } catch (e) {
            setSelectedDate(new Date());
            setLoading(false);
        }
    };

    const handleCloseNewMeetingModal = () => setShowNewMeetingModal(false);

    useEffect(() => {
        if (triggerMode === 'none' && openKey > 0) {
            handleShowNewMeetingModal();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openKey, triggerMode]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedDate || isNaN(selectedDate.getTime())) {
            toast.error('Please select a valid meeting date.', { position: 'bottom-left' });
            return;
        }
        setSaveLoading(true);
        const formattedDate = format(selectedDate, 'dd/MM/yyyy');
        try {
            const response = await fetch(`${url}/meeting`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + authUser.token
                },
                body: JSON.stringify({
                    agendaTemplate: agendaTemplate || undefined,
                    isContest: contestPluginEnabled && isContest,
                    contestTypes: contestPluginEnabled && isContest ? contestTypesSelected : [],
                    meetingDate: formattedDate,
                    meetingTime,
                    meetingMode,
                    meetingAddress: meetingMode === 'inPerson' ? meetingAddress : '',
                    meetingOnlineLink: meetingMode === 'online' ? meetingOnlineLink : '',
                    meetingOnlinePasscode: meetingMode === 'online' ? meetingOnlinePasscode : '',
                    meetingNumber,
                    meetingTheme,
                    meetingCardDisplayRole,
                    showClockText
                })
            });
            const result = await response.json();
            if (response.ok) {
                toast.success('Meeting added successfully', { position: 'bottom-left' });
                if (getMeetings) getMeetings();
                handleCloseNewMeetingModal();
            } else {
                toast.error(result.Error || 'Failed to add meeting', { position: 'bottom-left' });
            }
        } catch (error) {
            console.error('Error adding meeting:', error);
            toast.error('Failed to add meeting', { position: 'bottom-left' });
        } finally {
            setSaveLoading(false);
        }
    };

    return (
        <>
            {triggerMode === 'menu-item' ? (
                <button
                    type="button"
                    className="agenda-modal-item"
                    onClick={handleShowNewMeetingModal}
                >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add Meeting</span>
                </button>
            ) : triggerMode === 'button' ? (
                <Button onClick={handleShowNewMeetingModal} className='' variant='success' title="Add meeting">+ Add Meeting</Button>
            ) : null}
            <StandardModal
                navigationParent={navigationParent}
                show={showNewMeetingModal}
                handleClose={handleCloseNewMeetingModal}
                title="Add New Meeting"
                ModalBodyComponent={
                    loading || !selectedDate || isNaN(selectedDate.getTime()) ? (
                        <div style={{ width: '100%', textAlign: 'center', padding: '2rem' }}>Loading...</div>
                    ) : (
                        <Form id="meeting-add-form" onSubmit={handleSubmit}>
                            <Form.Group className='mb-3'>
                                <Form.Label>Meeting Date</Form.Label>
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={date => setSelectedDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>Time</Form.Label>
                                <Form.Control
                                    className='formInput'
                                    placeholder='Time: HH:mm'
                                    aria-label='Time'
                                    name='meetingTime'
                                    value={meetingTime}
                                    onChange={e => setMeetingTime(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>Meeting Mode</Form.Label>
                                <Form.Select
                                    aria-label='Meeting Mode'
                                    className='formInput'
                                    name='meetingMode'
                                    value={meetingMode}
                                    onChange={e => setMeetingMode(e.target.value)}
                                >
                                    <option value='inPerson'>In Person</option>
                                    <option value='online'>Online</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>{meetingMode === 'online' ? 'Meeting Link' : 'Location'}</Form.Label>
                                {meetingMode === 'online' ? (
                                    <Form.Control
                                        className='formInput'
                                        placeholder='Meeting Link'
                                        aria-label='Meeting Link'
                                        name='meetingOnlineLink'
                                        value={meetingOnlineLink}
                                        onChange={e => setMeetingOnlineLink(e.target.value)}
                                    />
                                ) : (
                                    <Form.Control
                                        className='formInput'
                                        placeholder='Location'
                                        aria-label='Location'
                                        name='meetingAddress'
                                        value={meetingAddress}
                                        onChange={e => setMeetingAddress(e.target.value)}
                                    />
                                )}
                            </Form.Group>
                            {meetingMode === 'online' && (
                                <Form.Group className='mb-3'>
                                    <Form.Label>Meeting Passcode (optional)</Form.Label>
                                    <Form.Control
                                        className='formInput'
                                        placeholder='Passcode (optional)'
                                        aria-label='Meeting Passcode'
                                        name='meetingOnlinePasscode'
                                        value={meetingOnlinePasscode}
                                        onChange={e => setMeetingOnlinePasscode(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                            <Form.Group className='mb-3'>
                                <Form.Label>Meeting Number</Form.Label>
                                <Form.Control
                                    className='formInput'
                                    placeholder='Meeting Number'
                                    aria-label='meetingNo'
                                    name='meetingNumber'
                                    value={meetingNumber}
                                    onChange={e => setMeetingNumber(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>Meeting Theme</Form.Label>
                                <Form.Control
                                    className='formInput'
                                    placeholder='Meeting Theme'
                                    aria-label='meeting Theme'
                                    name='meetingTheme'
                                    value={meetingTheme}
                                    onChange={e => setMeetingTheme(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>Display Role On Meeting Card</Form.Label>
                                <Select
                                    options={[...meetingRoles]
                                        .sort((a, b) => String(a?.name || '').localeCompare(String(b?.name || '')))
                                        .map(role => ({ value: role.name, label: role.name }))}
                                    className='formInput w-100'
                                    value={([
                                        ...meetingRoles.map(role => ({ value: role.name, label: role.name }))
                                    ].find(option => option.value === meetingCardDisplayRole) || null)}
                                    onChange={option => setMeetingCardDisplayRole(option ? option.value : 'Toastmaster')}
                                    isClearable={false}
                                    isSearchable
                                    styles={customStyles}
                                    menuPlacement="auto"
                                    menuPosition="fixed"
                                    menuPortalTarget={document.body}
                                    menuShouldScrollIntoView={false}
                                    maxMenuHeight={220}
                                    placeholder='Display role on meeting card'
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>Agenda Template</Form.Label>
                                <Form.Select
                                    className='formInput'
                                    aria-label='Agenda Template'
                                    name='agendaTemplate'
                                    value={agendaTemplate}
                                    onChange={e => setAgendaTemplate(e.target.value)}
                                >
                                    <option value=''>No Agenda Template</option>
                                    {agendaTemplates.map(template => (
                                        <option key={template._id} value={template._id}>{template.name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            {contestPluginEnabled && (
                                <Form.Group className='mb-3'>
                                    <Form.Check type='checkbox' label='Contest meeting' checked={isContest} onChange={e => { setIsContest(e.target.checked); if (!e.target.checked) setContestTypesSelected([]); }} />
                                    {isContest && <><Form.Select className='formInput mt-2' value='' onChange={e => { if (e.target.value && !contestTypesSelected.includes(e.target.value)) setContestTypesSelected(previous => [...previous, e.target.value]); }}><option value=''>Add contest type</option>{contestTypes.map(type => <option key={type._id} value={type._id}>{type.name}</option>)}</Form.Select><div className='mt-2'>{contestTypesSelected.map(typeId => <span className='badge bg-secondary me-2' key={typeId}>{contestTypes.find(type => type._id === typeId)?.name || typeId}<button type='button' className='btn-close btn-close-white ms-2' aria-label='Remove contest type' onClick={() => setContestTypesSelected(previous => previous.filter(id => id !== typeId))} /></span>)}</div></>}
                                </Form.Group>
                            )}
                            <Form.Group className='mb-3'>
                                <Form.Check
                                    type='checkbox'
                                    label='Show clock text during timer'
                                    checked={showClockText}
                                    onChange={e => setShowClockText(e.target.checked)}
                                />
                            </Form.Group>
                        </Form>
                    )
                }
                ModalFooterComponent={
                    <>
                        <Button variant="danger" onClick={handleCloseNewMeetingModal} disabled={saveLoading}>
                            Cancel
                        </Button>
                        <Button
                            variant="success"
                            type='submit'
                            form="meeting-add-form"
                            disabled={loading || saveLoading || !selectedDate || isNaN(selectedDate?.getTime?.())}
                        >
                            {saveLoading ? 'Adding meeting ...' : 'Add Meeting'}
                        </Button>
                    </>
                }
            />
        </>
    );
}